<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Body-Text-No-Indent-SpB4--Body- ParaOverride-1" lang="en-US"><img alt="image" src="image/1SeaLeopardZedect1.jpg"/></p>
<p class="ORIM-Body-Text-No-Indent-SpB4--Body- ParaOverride-1" lang="en-US"><img alt="image" src="image/2SeaLeopardZedect2.jpg"/></p>
<p class="ORIM-Body-Text-No-Indent-SpB4--Body- ParaOverride-1" lang="en-US"><img alt="image" src="image/3SeaLeopardPHMemo.jpg"/></p>
<p class="ORIM-Body-Text-No-Indent-SpB4--Body- ParaOverride-1" lang="en-US"><img alt="image" src="image/4SeaLeopardPSMemo.jpg"/></p>
<p class="ORIM-Body-Text-No-Indent-SpB4--Body- ParaOverride-1" lang="en-US"><img alt="image" src="image/5SeaLeopardUSNMemo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SeaLeopard2a.vue?831fffa2